// A round initials avatar. Users have no display name, only an email, so the letters come from
// the email's local part: "ama.mensah@…" → "AM", "owner@…" → "OW".
import { cn } from "./cn";

function initials(email: string): string {
  const parts = (email.split("@")[0] ?? "").split(/[._+-]+/).filter(Boolean);
  const [first = "?", second] = parts;
  return (second ? first.slice(0, 1) + second.slice(0, 1) : first.slice(0, 2)).toUpperCase();
}

const SIZE = { sm: "h-9 w-9 text-[13px]", lg: "h-14 w-14 text-lg" };

export function Avatar({ email, size = "sm", soft, className }: { email: string; size?: keyof typeof SIZE; soft?: boolean; className?: string }) {
  return (
    <span
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full font-display font-bold",
        soft ? "bg-primary-lighter text-primary" : "bg-primary text-primary-foreground",
        SIZE[size],
        className,
      )}
      aria-hidden
    >
      {initials(email)}
    </span>
  );
}
